import { AppState } from "editor/src/store/app/types";

/**
 * GAPI-30848 (new-product-after-edit-existing) — clears
 * `state.app.selectedTechByArea` while leaving `multiTechAreaGroups`
 * untouched. Host fires `variants.clearSelectedTechByArea` on every fresh
 * wizard session (resetState / initState) so the next product load doesn't
 * inherit the previous session's per-area tech picks via the preserve
 * branch in `initMultiTechAreaGroupsOperation`.
 *
 * `multiTechAreaGroups` is left in place on purpose: clearing it as well
 * would put the iframe into single-tech UI mode for the window between
 * this clear and the bridge's next `setMultiTechAreaGroups` send for the
 * new product, which made the bottom strip render all 4 (area × tech)
 * tiles. Keeping `multiTechAreaGroups` ensures the multi-tech filter stays
 * engaged across the transition.
 */
const clearSelectedTechByAreaReducer = (state: AppState): void => {
  state.selectedTechByArea = {};
};

export default clearSelectedTechByAreaReducer;
